import { useRequest } from '@/api/request'
import MiiaFwConfig from '@/configs/config'
import { ERROR_CODES } from '@/constants/error/errorCode'
import type {
  RunForPropscrParam,
  RunParam,
  RunResponse
} from '@/types/api/dup/runFileProcessorEcs/runFileProcessorEcs'
import type { ErrorCode } from '@/utils/globalError/entities/valueObjects/types'
import { GlobalError } from '@/utils/globalError/GlobalError'

export const useRunFileProcessorEcsApi = () => {
  const { request } = useRequest()

  /** ファイル処理ECS起動APIへリクエストする */
  const requestRunFileProcessorEcsApi = <T, U>(func: string, arg: T) => {
    return request<T, U>(MiiaFwConfig.config.apiGwEndpointDup, '/runFileProcessorEcs', func, arg)
  }

  /**
   * ファイル処理ECS起動API runを実行する
   * @param param リクエストパラメータ
   * @returns レスポンス
   */
  const runEcs = async (param: RunParam) => {
    const res = await requestRunFileProcessorEcsApi<RunParam, RunResponse>('run', param)
    if ('error' in res) {
      throw new GlobalError(
        [ERROR_CODES._811010_API_EXECUTION_FAILED, res.error.errorCode as ErrorCode],
        { message: res.error.errorMessage }
      )
    }
    return res.result
  }

  /**
   * ファイル処理ECS起動API runForPropscrを実行する
   * @param param リクエストパラメータ
   * @returns レスポンス
   */
  const runForPropscr = async (param: RunForPropscrParam) => {
    const res = await requestRunFileProcessorEcsApi<RunForPropscrParam, RunResponse>(
      'runForPropscr',
      param
    )
    if ('error' in res) {
      throw new GlobalError(
        [ERROR_CODES._811010_API_EXECUTION_FAILED, res.error.errorCode as ErrorCode],
        { message: res.error.errorMessage }
      )
    }
    return res.result
  }

  return { runEcs, runForPropscr }
}
